import * as yup from 'yup';
import { PAN_REGEX, AADHAR_REGEX, GST_REGEX, MOBILE_REGEX } from '../utils/agencyProfileConstants';
/* ---------------------------
Reusable Social URL Validator
----------------------------*/
const socialUrl = (domain, message) =>
  yup.string().nullable().test("url-validation", message, (value) => {
    if (!value) return true;
    const regex = new RegExp(`^(https?:\\/\\/)?(www\\.)?${domain}\\/.*`, "i");
    return regex.test(value);
  });

export const agencyProfileSchema = yup.object().shape({
    // Step 0: Personal
    yourName: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email required'),
    mobileNumber: yup.string().required('Mobile required'),
    alternateMobileNumber: yup.string().nullable().matches(MOBILE_REGEX, { message: 'Invalid mobile number', excludeEmptyString: true }),
    agencyName: yup.string().required('Agency Name required'),
    companyIncorporationDate: yup.date().nullable().required('Date required').max(new Date(), "Future dates not allowed"),
    countryOfResidence: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
}).nullable(), 
    specialization: yup.array().min(1, 'Select at least one specialization').required('Specialization is required'),
    website: yup.string().url('Invalid URL').nullable(),
    aboutAgency: yup.string().nullable(),
    gstNumber: yup.string().nullable().matches(GST_REGEX, { message: 'Invalid GST Number', excludeEmptyString: true }),
    
   panNumber: yup.string().nullable().test(
    'pan-validation',
    'Invalid PAN Card format',
    (value) => !value || PAN_REGEX.test(value.toUpperCase())
),

aadharNumber: yup.string().nullable().test(
    'aadhar-validation',
    'Aadhar must be 12 digits',
    (value) => !value || AADHAR_REGEX.test(value)
),

    // Step 1: Address
   
      addressType: yup.string().nullable(),
      pinCode: yup
        .string()
        .nullable()
        .test("pincode-check", "Pin Code must be 6 digits", (val) => !val || /^\d{6}$/.test(val)),
      addressLine1: yup.string().nullable(),
      addressLine2: yup.string().nullable(),
      state: yup.string().nullable(),
      district: yup.string().nullable(),

    // Step 2: Team Members
    teamMembers: yup.array().of(yup.object().shape({
        name: yup.string().required('Name required'),
        email: yup.string().email('Invalid email').required('Email required'),
        mobile: yup.string().matches(MOBILE_REGEX, 'Invalid mobile').required('Mobile required'),
        // designation: yup.string().required('Designation required'),
        designation: yup.object().shape({
            value: yup.string().required('Designation is required'), // Validate the 'value' property within the object
            label: yup.string().required(),
        }).nullable().required('Designation is required'), 
        // contactType: yup.string().required('Contact Type required'),
        contactType: yup.object().shape({
            value: yup.string().required('Contact Type is required'), // Validate the 'value' property within the object
            label: yup.string().required(),
        }).nullable().required('Contact Type is required'),
    })).min(1, 'At least one team member is required'),

    // Step 3: Social
    facebookProfileUrl: socialUrl(
    "facebook.com",
    "Enter valid Facebook URL"
  ),
    linkedinProfileUrl: socialUrl(
    "linkedin.com",
    "Enter valid LinkedIn URL"
  ),

    instagramProfileUrl: socialUrl(
    "instagram.com",
    "Enter valid Instagram URL"
  ),
    twitterProfileUrl: socialUrl(
    "x.com",
    "Enter valid Twitter URL"
  ),

    youtubeUrl:socialUrl(
    "(youtube.com|youtu.be)",
    "Enter valid YouTube URL"
  ),
   imdbUrl: socialUrl(
    "imdb.com",
    "Enter valid IMDB URL"
  ),
    whatsappNo: yup.string().nullable().matches(MOBILE_REGEX, { message: 'Invalid WhatsApp Number', excludeEmptyString: true }),
});